import moment from 'moment';
import { globalGetService, globalPutService, globalExportService } from '../../utils_v2/globalApiServices';
import { downloadFileType, getLocalStorageInfo } from '../../utils_v2';

export const getQmeTrackerApi = (query = {}) => globalGetService(`technical/claim-tracker/`, query);

export const updateQmeTrackerApi = (slug, data) => globalPutService(`technical/claim-tracker/${slug}/`, data);

export const getQmeTrackerUsersApi = () => globalGetService(`technical/users/`, {});

export const exportQmeTrackerApi = (query = {}, file) =>
  globalExportService(`technical/claim-tracker/`, { ...query, download: file.extension })
    .then(response => {
      downloadFileType(response, (`QME_Tracker_${getLocalStorageInfo().defaultLessor.name}_${moment().format('YYYY-MM-DD.')}`), file.extension);
    });
